module.exports = __webpack_public_path__ + "static/media/arrow-left-gray-solid.5a1c3918.png";